import { container, title } from 'assets/jss/material-kit-react.js'
import imagesStyle from 'assets/jss/material-kit-react/imagesStyles.js'

const introStyle = {
  section: {
    padding: '70px 0',
  },
  container,
  title: {
    ...title,
    position: 'relative',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
    textAlign: 'center',
  },
  subtitle: {
    ...title,
    position: 'relative',
    marginTop: '-15px',
    textDecoration: 'none',
    fontSize: '1.2rem',
    textAlign: 'center',
    // maxWidth: '500px',
    // margin: '10px auto 0',
  },
  inTabContainer: {
    overflowX: 'hidden',
  },
  content: {
    textIndent: '2em',
    paddingTop: '10px',
  },
  list: {
    color: 'black',
  },
  listMobile: {
    '@media (max-width: 960px)': {
      'margin-top': '-30px',
    },
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  imgContainer: {
    width: [['auto'], '!important'],
  },
  img: {
    height: '100%',
    width: 'auto',
  },
  coImages: {
    WebkitFilter: 'grayscale(100%)',
    filter: 'grayscale(100%)',
    WebkitTransition: '.3s ease-in-out',
    transition: '.3s ease-in-out',
    '&:hover': { WebkitFilter: 'grayscale(0)', filter: 'grayscale(0)' },
  },
  ...imagesStyle,
}

export default introStyle
